// Centralized KaTeX dependency boundary for imported-assessment mathematics.
import renderMathInElement from "katex/dist/contrib/auto-render.mjs"
import "katex/dist/katex.min.css"

export {renderMathInElement}
